import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import './../../styles/profesional/portafolio.css';
import * as globals from './../../components/GlobalScripts.js';
import Sidebar_left from './Sidebar_left';
import { Link } from 'react-router-dom';

const Profesional_portafolio = () => {
    let path_api = localStorage.getItem('path_api');
    const [user, setUser] = useState([]);
    const [formDataPortafolio, setFormDataPortafolio] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [showEditModal, setShowEditModal] = useState(false);
    const [formNewPortfolio, setFormNewPortfolio] = useState({
        titulo: "",
        descripcion: "",
        imagenes: []
    });
    const [formEditPortfolio, setFormEditPortfolio] = useState({
        titulo: "",
        descripcion: "",
        imagenes: []
    });
    const inputFileRef = useRef(null);
    const editInputFileRef = useRef(null);

    useEffect(() => {
        const user_cache = localStorage.getItem('user');
        if (user_cache) {
            let userParsed = JSON.parse(user_cache);
            setUser(userParsed);
            if (userParsed.portfolio) {
                setFormDataPortafolio(userParsed.portfolio);
            }
        }
    }, []);

    const toggleModal = () => {
        setShowModal(prev => !prev);
    };

    const toggleEditModal = () => {
        setShowEditModal(prev => !prev);
    };

    const handleNewPortfolioChange = (e) => {
        const { name, value } = e.target;
        setFormNewPortfolio(prev => ({ ...prev, [name]: value }));
    };

    const handleNewPortfolioImages = (e) => {
        const files = Array.from(e.target.files);
        const maxImages = 10;
        const maxIndividualSize = 6 * 1024 * 1024;
        const maxTotalSize = 50 * 1024 * 1024;
        let currentTotalSize = formNewPortfolio.imagenes.reduce((acc, curr) => acc + curr.file.size, 0);
        let newImages = [];
        for (let file of files) {
            if (file.size > maxIndividualSize) {
                globals.createAlert({
                    type: "error",
                    msg_title: "Error",
                    msg: `La imagen ${file.name} excede el tamaño máximo de 6MB.`,
                    effect: "opacidad 2s, desplazamiento 2s",
                    time_life: 4000
                });
                continue;
            }
            if (formNewPortfolio.imagenes.length + newImages.length >= maxImages) {
                globals.createAlert({
                    type: "error",
                    msg_title: "Error",
                    msg: "Se ha alcanzado el límite máximo de 10 imágenes.",
                    effect: "opacidad 2s, desplazamiento 2s",
                    time_life: 4000
                });
                break;
            }
            if (currentTotalSize + file.size > maxTotalSize) {
                globals.createAlert({
                    type: "error",
                    msg_title: "Error",
                    msg: "El total de imágenes excede el tamaño máximo de 50MB.",
                    effect: "opacidad 2s, desplazamiento 2s",
                    time_life: 4000
                });
                break;
            }
            currentTotalSize += file.size;
            newImages.push({
                file: file,
                estado: "por_subir"
            });
        }
        setFormNewPortfolio(prev => ({ ...prev, imagenes: [...prev.imagenes, ...newImages] }));
        if (inputFileRef.current) {
            inputFileRef.current.value = "";
        }
    };

    const handleRemoveImage = (index) => {
        setFormNewPortfolio(prev => {
            const updatedImages = prev.imagenes.filter((img, i) => i !== index);
            return { ...prev, imagenes: updatedImages };
        });
    };

    const handleSubmitNewPortfolio = async (e) => {
        e.preventDefault();
        const formData = new FormData();
        formData.append('rute', globals.getRuteBackend());
        formData.append('session_id', globals.get_session_id());
        formData.append('keylogin', globals.get_keylogin());
        formData.append('titulo', formNewPortfolio.titulo);
        formData.append('descripcion', formNewPortfolio.descripcion);
        formNewPortfolio.imagenes.forEach((img, index) => {
            formData.append(`imagenes[${index}][file]`, img.file);
            formData.append(`imagenes[${index}][estado]`, img.estado);
        });
        globals.openViewCharge();
        axios.post(`${path_api}/update-account/add-portfolio.php`, formData, {
            headers: { 'Content-Type': 'multipart/form-data' }
        }).then(response => {
            if (response.data.mensaje === 'success') {
                globals.createAlert({
                    type: "success",
                    msg_title: "Éxito",
                    msg: "Proyecto agregado exitosamente",
                    effect: "opacidad 2s, desplazamiento 2s",
                    time_life: 4000
                });
                localStorage.setItem('user', JSON.stringify(response.data.user));
                setFormDataPortafolio(response.data.user.portfolio);
                setFormNewPortfolio({ titulo: "", descripcion: "", imagenes: [] });
                setShowModal(false);
            } else {
                globals.createAlert({
                    type: "error",
                    msg_title: "Error",
                    msg: response.data.mensaje || "No se pudo agregar el proyecto",
                    effect: "opacidad 2s, desplazamiento 2s",
                    time_life: 4000
                });
            }
        }).catch(error => {
            globals.createAlert({
                type: "error",
                msg_title: "Error",
                msg: "Error al agregar el proyecto",
                effect: "opacidad 2s, desplazamiento 2s",
                time_life: 4000
            });
        }).finally(() => {
            globals.closeViewCharge();
        });
    };

    const handleEdit = (index) => {
        const portfolioToEdit = formDataPortafolio[index];
        setFormEditPortfolio({
            id: portfolioToEdit.id,
            titulo: portfolioToEdit.titulo || "",
            descripcion: portfolioToEdit.descripcion || "",
            imagenes: portfolioToEdit.imagenes ? [...portfolioToEdit.imagenes] : []
        });
        setShowEditModal(true);
    };

    const handleDelete = (index) => {
        globals.openViewCharge();
        axios.post(`${path_api}/update-account/delete-portfolio.php`, {
            rute: globals.getRuteBackend(),
            session_id: globals.get_session_id(),
            keylogin: globals.get_keylogin(),
            portafolio: formDataPortafolio[index]
        })
        .then(response => {
            if (response.data.mensaje === 'success') {
                globals.createAlert({
                    type: "success",
                    msg_title: "Éxito",
                    msg: "Proyecto eliminado exitosamente.",
                    effect: "opacidad 2s, desplazamiento 2s",
                    time_life: 4000
                });
                localStorage.setItem('user', JSON.stringify(response.data.user));
                setFormDataPortafolio(response.data.user.portfolio);
            } else {
                globals.createAlert({
                    type: "error",
                    msg_title: "Error",
                    msg: response.data.mensaje || "No se pudo eliminar el proyecto.",
                    effect: "opacidad 2s, desplazamiento 2s",
                    time_life: 4000
                });
            }
        })
        .catch(error => {
            globals.createAlert({
                type: "error",
                msg_title: "Error",
                msg: "Error al eliminar el proyecto.",
                effect: "opacidad 2s, desplazamiento 2s",
                time_life: 4000
            });
        })
        .finally(() => {
            globals.closeViewCharge();
        });
    };    

    const handleEditChange = (e) => {
        const { name, value } = e.target;
        setFormEditPortfolio(prev => ({ ...prev, [name]: value }));
    };

    const handleEditImages = (e) => {
        const files = Array.from(e.target.files);
        const maxImages = 10;
        const maxIndividualSize = 6 * 1024 * 1024;
        const maxTotalSize = 50 * 1024 * 1024;
        let currentTotalSize = formEditPortfolio.imagenes.reduce((acc, curr) => acc + (curr.file ? curr.file.size : 0), 0);
        let newImages = [];
        for (let file of files) {
            if (file.size > maxIndividualSize) {
                globals.createAlert({
                    type: "error",
                    msg_title: "Error",
                    msg: `La imagen ${file.name} excede el tamaño máximo de 6MB.`,
                    effect: "opacidad 2s, desplazamiento 2s",
                    time_life: 4000
                });
                continue;
            }
            if (formEditPortfolio.imagenes.length + newImages.length >= maxImages) {
                globals.createAlert({
                    type: "error",
                    msg_title: "Error",
                    msg: "Se ha alcanzado el límite máximo de 10 imágenes.",
                    effect: "opacidad 2s, desplazamiento 2s",
                    time_life: 4000
                });
                break;
            }
            if (currentTotalSize + file.size > maxTotalSize) {
                globals.createAlert({
                    type: "error",
                    msg_title: "Error",
                    msg: "El total de imágenes excede el tamaño máximo de 50MB.",
                    effect: "opacidad 2s, desplazamiento 2s",
                    time_life: 4000
                });
                break;
            }
            currentTotalSize += file.size;
            newImages.push({
                file: file,
                estado: "por_subir"
            });
        }
        setFormEditPortfolio(prev => ({ ...prev, imagenes: [...prev.imagenes, ...newImages] }));
        if (editInputFileRef.current) {
            editInputFileRef.current.value = "";
        }
    };

    const handleRemoveEditImage = (index) => {
        setFormEditPortfolio(prev => {
            const updatedImages = prev.imagenes.map((img, i) => {
                if (i === index) {
                    return { ...img, estado: "por_eliminar" };
                }
                return img;
            });
            return { ...prev, imagenes: updatedImages };
        });
    };

    const handleSubmitEditPortfolio = async (e) => {
        e.preventDefault();
        const formData = new FormData();
        formData.append('rute', globals.getRuteBackend());
        formData.append('session_id', globals.get_session_id());
        formData.append('keylogin', globals.get_keylogin());
        formData.append('id', formEditPortfolio.id);
        formData.append('titulo', formEditPortfolio.titulo);
        formData.append('descripcion', formEditPortfolio.descripcion);
        formEditPortfolio.imagenes.forEach((img, index) => {
            if (img.file && img.file instanceof File) {
                formData.append(`imagenes[${index}][file]`, img.file);
            } else if (img.ruta) {
                formData.append(`imagenes[${index}][ruta]`, img.ruta);
            }
            formData.append(`imagenes[${index}][estado]`, img.estado);
        });
        globals.openViewCharge();
        axios.post(`${path_api}/update-account/edit-portfolio.php`, formData, {
            headers: { 'Content-Type': 'multipart/form-data' }
        }).then(response => {
            if (response.data.mensaje === 'success') {
                globals.createAlert({
                    type: "success",
                    msg_title: "Éxito",
                    msg: "Proyecto actualizado exitosamente",
                    effect: "opacidad 2s, desplazamiento 2s",
                    time_life: 4000
                });
                localStorage.setItem('user', JSON.stringify(response.data.user));
                setFormDataPortafolio(response.data.user.portfolio);
                setFormEditPortfolio({ id: "", titulo: "", descripcion: "", imagenes: [] });
                setShowEditModal(false);
            } else {
                globals.createAlert({
                    type: "error",
                    msg_title: "Error",
                    msg: response.data.mensaje || "No se pudo actualizar el proyecto",
                    effect: "opacidad 2s, desplazamiento 2s",
                    time_life: 4000
                });
            }
        }).catch(error => {
            globals.createAlert({
                type: "error",
                msg_title: "Error",
                msg: "Error al actualizar el proyecto",
                effect: "opacidad 2s, desplazamiento 2s",
                time_life: 4000
            });
        }).finally(() => {
            globals.closeViewCharge();
        });
    };
    

    return (
        <>
            <div className='container-profesional page-portafolio container-section'>
                <div className='left-side'>
                    <Sidebar_left />
                </div>
                <div className="right-side">
                    <div className='sticky-form'>
                        <button className="button-primary" onClick={toggleModal}>
                            Agregar
                        </button>
                    </div>
                    <h2>Portafolio</h2>
                    <div className="portafolio-list">
                        {formDataPortafolio && formDataPortafolio.length > 0 ? (
                            formDataPortafolio.map((portfolio, index) => (
                                <div key={index} className="portafolio-item">
                                    <h3>{portfolio?.titulo}</h3>
                                    <p>{portfolio?.descripcion}</p>
                                    {portfolio.imagenes && portfolio.imagenes.length > 0 && (
                                        <div className="portfolio-images">
                                            {portfolio.imagenes.map((img, i) => (
                                                <div className="image" key={i}>
                                                    <Link to={path_api + img.ruta} target='_blank'>
                                                        <img src={path_api + img.ruta} alt={`Imagen ${i + 1}`} />
                                                    </Link>
                                                </div>
                                            ))}
                                        </div>
                                    )}
                                    <div className="portfolio-actions">
                                        <button className="edit-button" onClick={() => handleEdit(index)}>
                                            <svg viewBox="0 0 24 24">
                                                <path d="M3 17.25V21h3.75l11-11-3.75-3.75-11 11zM20.71 7.04a1.003 1.003 0 0 0 0-1.41l-2.34-2.34a1.003 1.003 0 0 0-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z" />
                                            </svg>
                                        </button>
                                        <button className="delete-button" onClick={() => handleDelete(index)}>
                                            <svg viewBox="0 0 24 24">
                                                <path d="M16 9v10H8V9h8m-1.5-6h-5l-1 1H5v2h14V4h-3.5l-1-1z" />
                                            </svg>
                                        </button>
                                    </div>
                                </div>
                            ))
                        ) : (
                            <h5>No tienes proyectos para mostrar.</h5>
                        )}
                    </div>
                </div>
                {showModal && (
                <div className='modal-container'>
                    <div className="modal">
                        <div className='container-close-button'>
                            <button className="close-button" onClick={toggleModal} aria-label="Cerrar">
                                <svg viewBox="0 0 24 24">
                                    <path d="M18.3 5.71a1 1 0 00-1.42-1.42L12 9.17 7.12 4.29a1 1 0 00-1.42 1.42L10.59 12l-4.89 4.88a1 1 0 001.42 1.42L12 14.83l4.88 4.89a1 1 0 001.42-1.42L13.41 12l4.89-4.88z" />
                                </svg>
                            </button>
                        </div>
                        <h2>Agregar proyecto</h2>
                        <form onSubmit={handleSubmitNewPortfolio} className="flex-column gap-20">
                            <div className="form-group">
                                <label htmlFor="titulo">Título</label>
                                <input
                                    type="text"
                                    id="titulo"
                                    name="titulo"
                                    value={formNewPortfolio.titulo}
                                    onChange={handleNewPortfolioChange}
                                    className="input-primary"
                                    required
                                />
                            </div>
                            <div className="form-group">
                                <label htmlFor="descripcion">Descripción</label>
                                <textarea
                                    id="descripcion"
                                    name="descripcion"
                                    value={formNewPortfolio.descripcion}
                                    onChange={handleNewPortfolioChange}
                                    className="input-primary"
                                    rows="4"
                                    required
                                />
                            </div>
                            <div className="form-group">
                                <label htmlFor="imagenes">Imágenes</label>
                                <input
                                    type="file"
                                    id="imagenes"
                                    name="imagenes"
                                    onChange={handleNewPortfolioImages}
                                    className="input-primary"
                                    accept="image/*"
                                    multiple
                                    ref={inputFileRef}
                                />
                            </div>
                            {formNewPortfolio.imagenes && formNewPortfolio.imagenes.length > 0 && (
                                <div className="portfolio-images-preview">
                                    {formNewPortfolio.imagenes.map((img, index) => (
                                        <div key={index} className="image-preview">
                                            <img src={URL.createObjectURL(img.file)} alt={`Preview ${index + 1}`} />
                                            <p>{img.file.name}</p>
                                            <button type="button" onClick={() => handleRemoveImage(index)}>
                                                Eliminar
                                            </button>
                                        </div>
                                    ))}
                                </div>
                            )}
                            <div className='buttons-modal'>
                                <button className='button-primary' type="submit">Agregar</button>
                            </div>
                        </form>
                    </div>
                </div>
            )}
            {showEditModal && (
                <div className='modal-container'>
                    <div className="modal">
                        <div className='container-close-button'>
                            <button className="close-button" onClick={toggleEditModal} aria-label="Cerrar">
                                <svg viewBox="0 0 24 24">
                                    <path d="M18.3 5.71a1 1 0 00-1.42-1.42L12 9.17 7.12 4.29a1 1 0 00-1.42 1.42L10.59 12l-4.89 4.88a1 1 0 001.42 1.42L12 14.83l4.88 4.89a1 1 0 001.42-1.42L13.41 12l4.89-4.88z" />
                                </svg>
                            </button>
                        </div>
                        <h2>Editar proyecto</h2>
                        <form onSubmit={handleSubmitEditPortfolio} className="flex-column gap-20">
                            <div className="form-group">
                                <label htmlFor="titulo">Título</label>
                                <input
                                    type="text"
                                    id="titulo"
                                    name="titulo"
                                    value={formEditPortfolio.titulo}
                                    onChange={handleEditChange}
                                    className="input-primary"
                                    required
                                />
                            </div>
                            <div className="form-group">
                                <label htmlFor="descripcion">Descripción</label>
                                <textarea
                                    id="descripcion"
                                    name="descripcion"
                                    value={formEditPortfolio.descripcion}
                                    onChange={handleEditChange}
                                    className="input-primary"
                                    rows="4"
                                    required
                                />
                            </div>
                            <div className="form-group">
                                <label htmlFor="imagenes">Imágenes</label>
                                <input
                                    type="file"
                                    id="imagenes"
                                    name="imagenes"
                                    onChange={handleEditImages}
                                    className="input-primary"
                                    accept="image/*"
                                    multiple
                                    ref={editInputFileRef}
                                />
                            </div>
                            {formEditPortfolio.imagenes && formEditPortfolio.imagenes.filter(img => img.estado !== "por_eliminar").length > 0 && (
                                <div className="portfolio-images-preview">
                                    {formEditPortfolio.imagenes.filter(img => img.estado !== "por_eliminar").map((img, index) => (
                                        <div key={index} className="image-preview">
                                            {img.file ? (
                                                <img src={URL.createObjectURL(img.file)} alt={`Preview ${index + 1}`} />
                                            ) : (
                                                <img src={path_api + img.ruta} alt={`Imagen ${index + 1}`} />
                                            )}
                                            <p>{img.file ? img.file.name : "Imagen subida"}</p>
                                            <button type="button" onClick={() => handleRemoveEditImage(index)}>
                                                Eliminar
                                            </button>
                                        </div>
                                    ))}
                                </div>
                            )}
                            <div className='buttons-modal'>
                                <button className='button-primary' type="submit">Guardar cambios</button>
                            </div>
                        </form>
                    </div>
                </div>
            )}
            </div>
        </>
    );
};

export default Profesional_portafolio;
